export default "__VITE_ASSET__CPE07Vlh__"